export { RoleplayTag, type RoleplayTagProps } from './RoleplayTag';
